import { render, staticRenderFns } from "./SellerSidebar.vue?vue&type=template&id=23a9bec3&scoped=true&"
import script from "./SellerSidebar.vue?vue&type=script&lang=js&"
export * from "./SellerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a9bec3",
  null
  
)

export default component.exports